// https://medium.com/@alshakero/how-to-setup-your-web-app-manifest-dynamically-using-javascript-f7fbee899a61 
// https://technowhisp.com/dynamic-pwa-manifest/ 

import { useIconFolder } from "../../App";
import { isMeProd } from "../../project/appConfiguration";
import { manifestSizes } from "../components/imaging/createManifestIcons";

const _alertUrl = false

export const ammendManifestSettings = async (manifest_state, appName, callback, settingsDocName) => {

  const { settingsGlobal: aps_global, manifestIcons } = manifest_state ?? {}
  const { manifest, themeColors, themedItems } = aps_global ?? {}

  if (!manifest) {
    return callback(false, null);  // Early return if no manifest
  }

  const _manifestIcons = manifestIcons;
  let _xMan;

  try {
    const xMan = getDynamicManifext(manifest, themeColors, _manifestIcons, themedItems, appName)
    _xMan = xMan;

    // Convert manifest to JSON and create a Blob URL
    const json = JSON.stringify(xMan);
    const blob = new Blob([json], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);

    // Create and inject the manifest link element
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestURL;

    const existing = document.querySelector('link[rel="manifest"]');
    if (existing) {
      document.head.removeChild(existing);
    }

    // Append the link element to the head
    document.head.appendChild(link);

    // Assuming successful injection
    callback(true, _xMan);

    // // Example of adding the dynamic manifest directly into the page
    // const stringManifest = JSON.stringify(xMan);
    // let content = encodeURIComponent(stringManifest);
    // let url = "data:application/manifest+json," + content;

    // // Create and inject the manifest link tag
    // let element = document.createElement('link');
    // element.setAttribute('rel', 'manifest');
    // element.setAttribute('href', url);
    // document.querySelector('head').appendChild(element);

    // // Assuming successful injection
    // callback(true, _xMan);
  } catch (error) {
    console.error("Error in updating manifest:", error);
    callback(false, null);
  }
}

const getMi = (index, mis, publicUrl) => {
  const mii = manifestSizes[index];
  const def = !useIconFolder ? publicUrl.href + "icon-" + mii + "x" + mii + ".png" : publicUrl.href + "icons/icon-" + mii + "x" + mii + ".png";

  // Fallback to default icon if specific icon is missing
  const mi = mis && mis['manifest_' + index] && mis['manifest_' + index].fileUrl ? mis['manifest_' + index].fileUrl : def;
  return mi;
}


/**
 * 
 * @param {object} manifest 
 * @param {object} themeColors 
 * @param {object} manifestIcons 
 * @param {object} themedItems 
 * @returns 
 */
const getDynamicManifext = (manifest, themeColors, manifestIcons, themedItems, appName) => {

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  const manifestColors = themedItems && themedItems.manifest && themedItems.manifest.colors && themedItems.manifest.colors.apply ? themedItems.manifest.colors : null
  const { shortName, startUrl, colors, id } = manifest ?? {}
  let { name } = manifest ?? {}
  const clrs = manifestColors ? manifestColors : colors
  const { backgroundColor, color } = clrs ?? {}
  const bc = themeColors && backgroundColor && themeColors[backgroundColor] ? themeColors[backgroundColor] : "#0080c5"
  const c = themeColors && color && themeColors[color] ? themeColors[color] : "#23b099"

  const _shortName = isMeProd() ? shortName : shortName + '*'

  if (name === 'name') { name = appName }

  const m = {
    "name": name ? name : appName,
    "short_name": _shortName ? _shortName : "MEM",
    "start_url": startUrl ? startUrl : window.document.URL,
    "theme_color": c,
    "background_color": bc,
    "display": "standalone",
    "orientation": "portrait-primary",
    "gcm_sender_id": "103953800507",
    "id": id ? id : 'me',
    icons: [
      {
        src: getMi(0, manifestIcons, publicUrl),
        sizes: "72x72",
        type: "image/png",
      },
      {
        src: getMi(1, manifestIcons, publicUrl),
        sizes: "96x96",
        type: "image/png"
      },
      {
        src: getMi(2, manifestIcons, publicUrl),
        sizes: "128x128",
        type: "image/png"
      },
      {
        src: getMi(3, manifestIcons, publicUrl),
        sizes: "144x144",
        type: "image/png"
      },
      {
        src: getMi(4, manifestIcons, publicUrl),
        sizes: "152x152",
        type: "image/png"
      },
      {
        src: getMi(5, manifestIcons, publicUrl),
        sizes: "192x192",
        type: "image/png"
      },
      {
        src: getMi(6, manifestIcons, publicUrl),
        sizes: "384x384",
        type: "image/png"
      },
      {
        src: getMi(7, manifestIcons, publicUrl),
        sizes: "512x512",
        type: "image/png"
      }
    ]
  }

  if (_alertUrl) {
    alert(m.start_url)
  }
  return m
}